module.exports = __webpack_public_path__ + "img/devices_2_375.0ed8536.jpg";